import { Component } from '@angular/core';
import { BaseIndexPageComponent } from 'src/app/components/pages/base-index-page/base-index-page.component';
import BaseIndexPageConfig from 'src/app/components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from 'src/app/components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from 'src/app/components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from 'src/app/services/api/api-options.config';
import { CompaniesService } from 'src/app/services/api/general-settings/companies.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-companies-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './companies-index-page.component.html',
  styleUrl: './companies-index-page.component.scss'
})
export class CompaniesIndexPageComponent {
  list: any[] = [];
  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected companiesService: CompaniesService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Companies',
      cardTitle: 'Manage Companies',
      addNewItemButton: {
        type: 'success',
        title: 'Add Company',
        onClick: () => {
          this.routeService.companyCreate()
        }
      },
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'code',
            header: 'Code',
            filter: 'text',
            value: (item: any) => {
              return item.code;
            }
          }),
          new DataTableColumnText({
            attribute: 'name',
            header: 'Name',
            filter: 'text',
            value: (item: any) => {
              return item.name;
            }
          }),
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View company details',
                onClick: (item: any) => {
                  this.routeService.companyDetail(item.companyId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit company',
                onClick: (item: any) => {
                  this.routeService.companyUpdate(item.companyId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete company',
                onClick: (item: any) => {
                  this.baseIndexPageConfig.dataTable.data = this.baseIndexPageConfig.dataTable.data.filter((company: any) => company.companyId !== item.companyId);
                },
                isDelete: true
              },

            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.companiesService.list(options),
      responseListModelName: 'companies',
    }
  }
}
